import { DirectUpload } from "@rails/activestorage";

export default class Uploader {
  constructor(file, input, consultationId, backup) {
    this.input = input;
    this.form = input.form;
    this.upload = new DirectUpload(file, input.dataset.directUploadUrl, this);
    this.consultationId = consultationId;
    this.backup = backup;
  }

  uploadFile() {
    this.upload.create(async (error, blob) => {
      if (error) {
        window.location.replace(
          `/consultations/${this.consultationId}?error=recording`,
        );
      } else {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("value", blob.signed_id);
        hiddenField.name = this.input.name;

        this.form.appendChild(hiddenField);

        await new Promise((resolve, reject) => {
          this.form.addEventListener("turbo:submit-end", ({ detail: { success } }) => {
            success ? resolve() : reject();
          }, { once: true });
          this.form.requestSubmit();
        });

        await this.backup.deleteRecording();
        document.dispatchEvent(new CustomEvent("vetomatic:upload-complete"));
      }
    });
  }

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress", (event) =>
      this.directUploadDidProgress(event),
    );
  }

  directUploadDidProgress(event) {
    const progressText = document.getElementById("progress-text");
    const progressBar = document.getElementById("progress-bar");
    if (!progressText) return;

    const progress = (event.loaded / event.total) * 100;
    progressText.innerText = `${Math.round(progress)}%`;
    progressBar.style.width = `${progress}%`;
  }
}
